export const MAP_DEFAULT_STATE = {
  center: [54.301492, 48.470614],
  zoom: 10
}
